import DashboardApi from './_dashboardApi';
import httpClient from '@/apis/base/httpclient';
class DashboardSurplusDeficitAPI extends DashboardApi {
  constructor() {
    super();
  }
  controllerName = 'Dashboards';

  /**
   * Lấy dữ liệu cho biểu đồ 3 thặng dư/ thâm hụt nguồn NSNN
   * DDHung 20.06.2023
   */
  getSurplusDeficitData(param) {
    let request = {
      url: this.getAPIUrl() + '/SurplusDeficit',
      data: param,
    };
    return httpClient.postAsync(request);
  }


  /**
   * Lấy dữ liệu combobox biểu đồ 3
   * DDHung 20.06.2023
   */
  GetBudgetSourceComboSurplusDeficit() {
    let request = {
      url: this.getAPIUrl() + '/GetBudgetSourceComboSurplusDeficit',
    };
    return httpClient.postAsync(request);
  }
  
  /**
   * Lấy dữ liệu combobox load paging
   */
  getComboboxPaging(payload) {
  let param = { ...payload };
  let request = {
    url: this.getAPIUrl() + '/DataChartArises',
    data: param,
  };
  return httpClient.postAsync(request);
}
  /**
   * Lấy dữ liệu cho biểu đồ 3 thặng dư/ thâm hụt nguồn NSNN
   * DDHung 20.06.2023
   */
  async getChartData(param) {
    let request = {
      url: this.getAPIUrl() + '/DataChart',
      data: param,
    };
    let data = await httpClient.postAsync(request);
    return data;
  }

  /**
   * Lấy dữ liệu cho biểu đồ 3 thặng dư/ thâm hụt nguồn NSNN
   * NBTIN 28.05.2024
   */
  async getChartDataMisaAva(param) {
    let request = {
      url: this.getAPIUrl() + '/DataChartMisaAva',
      data: param,
    };
    let data = await httpClient.postAsync(request);
    return data;
  }
}

export default new DashboardSurplusDeficitAPI();
